import React from 'react'
import './styles.scss'
import ButtonCircle from '../../components/button_circle'

export const Modal = ({ children, onClose, title }: { children: any, title?:string, onClose: any }) => {
    return (
        <div className="modal">
            <div className="modal__overlay" onClick={onClose}></div>
            <div className="modal__content">
                <div className="consolidate_files_container_header">
                    <div>{title}</div>
                    <ButtonCircle icon="/assets/icons/close.svg" iconHeight={15} iconWidth={15} onClick={onClose} />
                </div>
                {children}
            </div>
        </div>
    )
}
